import DeleteNotebookMenuItem from "./notebook-context-menu/delete-notebook-menu-item";
import Icon from "atoms/icons/icon";
import MenuButton from "molecules/menu-button/menu-button";
import React from "react";
import UseNotebookSidebar from "pages/notebooks/sidebar/use-notebook-sidebar";
import useNotebookActions from "pages/notebooks/use-notebook-actions";
import { ConfirmationModal } from "molecules/modals/confirmation-modal";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import { Link } from "react-router-dom";
import { t } from "utilities/localization-utils";
import OpenNotebookMenuItem from "pages/notebooks/sidebar/notebook-context-menu/open-notebook-menu-item";
import { ModalTypes } from "molecules/constants/modal-types";
import { Breakpoints } from "utilities/enumerations/breakpoints";
import useBreakpoint, {
    BreakpointComparer,
} from "utilities/hooks/use-breakpoint";
import { ModalCloseButtonStyle } from "molecules/constants/modal-close-button-style";
import useToggleNotebookSidebar from "../use-toggle-notebook-sidebar";
import ShareNotebookMenuItem from "pages/notebooks/sidebar/notebook-context-menu/share-notebook-menu-item";
import NotebookShareModal from "organisms/modals/notebook-share-modal/notebook-share-modal";
import NotebookRecord from "models/view-models/notebook-record";
import { useGlobalState } from "utilities/contexts/use-global-state-context";

const BASE_CLASS_NAME = "c-notebook-sidebar";

const NotebookPanel = ({ notebook }: { notebook: NotebookRecord }) => {
    const { notebookRoute, getNotebookClassModifier } = UseNotebookSidebar();
    const { toggleDisplay } = useToggleNotebookSidebar();
    const userId = useGlobalState().globalState.currentIdentity?.userId();
    const isShared = notebook.ownerId !== userId;
    const isMobile = useBreakpoint(
        Breakpoints.SmallTablet,
        BreakpointComparer.MaxWidth
    );
    const modalType = isMobile ? ModalTypes.Bottom : ModalTypes.Base;

    const {
        showDeleteConfirmModal,
        setShowDeleteConfirmModal,
        deleteNotebook,
        setShowShareModal,
        showShareModal,
    } = useNotebookActions(notebook);

    const handleDeleteRequest = () => {
        setShowDeleteConfirmModal(true);
    };

    const handleShareRequest = () => {
        setShowShareModal(true);
    };

    const handleConfirmDelete = () => {
        deleteNotebook();
    };
    const closeIfSidebarMobile = () => {
        if (isMobile) {
            toggleDisplay();
        }
    };
    return (
        <div
            className={`${BASE_CLASS_NAME}__notebookPanel ${getNotebookClassModifier(notebook.id!)}`}
            key={`${notebook.id}`}>
            <Link
                to={notebookRoute(notebook.id!)}
                className={`${BASE_CLASS_NAME}__link -notebook `}
                onClick={closeIfSidebarMobile}>
                {notebook.name}
            </Link>
            {!isShared && (
                <>
                    <div className={`${BASE_CLASS_NAME}__menu`}>
                        <MenuButton
                            buttonAccessibleText={t("actionsForItem", {
                                item: notebook.name,
                            })}
                            icon={Icons.MoreHorizontal}
                            iconSize={IconSizes.Medium}>
                            <OpenNotebookMenuItem notebook={notebook} />
                            <DeleteNotebookMenuItem
                                notebook={notebook}
                                onClick={handleDeleteRequest}
                            />
                            <ShareNotebookMenuItem
                                onClick={handleShareRequest}
                                notebook={notebook}
                            />
                        </MenuButton>
                    </div>
                    <ConfirmationModal
                        type={modalType}
                        closeButtonStyle={ModalCloseButtonStyle.Hidden}
                        confirmButtonText={t("yesAction", {
                            action: t("delete"),
                        })}
                        isVisible={showDeleteConfirmModal}
                        label={t("notebook-deleteLabel")}
                        message={t("notebook-deleteMessage")}
                        onCancel={() => setShowDeleteConfirmModal(false)}
                        onConfirm={handleConfirmDelete}
                    />
                    {showShareModal && (
                        <NotebookShareModal
                            notebook={notebook}
                            isVisible={showShareModal}
                            closeDialog={() => setShowShareModal(false)}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default NotebookPanel;
